import { Box, ListItemText, ListItem, Tab, Tabs, TextField, Typography, Divider, List, Grid, Alert, CardHeader, FormControl, CardContent, Card, InputLabel, Checkbox, CardActions, InputAdornment, inputBaseClasses, CircularProgress, Tooltip } from "@mui/material";
import React from "react";
import ErrorBoundary from "../Common/ErrorBoundary";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import ReactSelect from 'react-select';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import makeAnimated from 'react-select/animated';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DataGrid, GridActionsCellItem, GridEventListener, GridRowEditStopParams, GridRowEditStopReasons, GridRowId, GridRowModel, GridRowModes, GridRowModesModel } from "@mui/x-data-grid";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ErrorIcon from '@mui/icons-material/Error';
import MinusIcon from '@mui/icons-material/Remove';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import axios from "axios";
import UploadFile from "../Whisper/UploadFile/UploadFile";
import * as XLSX from 'xlsx';
import UploadedFileDataTable from "../Whisper/UploadFile/UploadedFileDataTable";

interface ExcelData {
    [key: string]: string | number | boolean;
}

interface OptionType {
    id: number;
    sys_id: string;
    value: string;
    label: string;
}

export default class Whisper extends React.Component {
    animatedComponents = makeAnimated();
    state = {
        steps: ['Add whisper text', 'Assign customer(s)', 'Review and save'],
        loading: false,
        activeStep: 0,
        skipped: new Set<number>(),
        error: false,
        success: false,
        failed: {},
        message: '',
        // mode: localStorage.getItem('theme') || 'light',
        mode: 'light',
        whisper: '',
        locations: [],
        customers: [],
        // channels: [],
        selectedLocations: [],
        filteredCustomers: [],
        filteredSelectedCustomers: [],
        selectedCustomers: [] as { id: number, name: string }[],
        // selectedChannel: null as OptionType | null,
        value: '0',
        customerId: '',
        expanded: 'false',
        isCheckboxAllLocationsChecked: false,
        isCheckboxAllCustomersChecked: false,
        outer_tab_index: 0,
        all_steps_completed: false,
    }


    handleOuterTabIndexChange = (event: React.SyntheticEvent, newValue: number) => {
        this.setState({ outer_tab_index: newValue });
    }

    componentDidMount() {
        setTimeout(() => {
            fetch(`/admin/customers/?entity_id=${localStorage.getItem('entity_id')}`)
                .then(response => response.json())
                .then(data => this.setState({ customers: data['customers'], locations: data['locations'] }));
                // .then(data => this.setState({ customers: data['customers'], channels: data['channels'] }));
            // this.setState({ loading: true });
        }, 1000);
    }

    handleAccordionChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        this.setState({ expanded: isExpanded ? panel : false });
    }

    handleChange = (selected: OptionType[]) => {
        this.setState({ selectedCustomers: selected.map((opt: { id: number, label: string, value: string, sys_id: string }) => ({
            id: opt.id,
            sys_id: opt.sys_id,
            label: opt.label,
            name: opt.value,
        })) });
        this.setState({ filteredSelectedCustomers: [], filteredCustomers: [], selectedLocations: [], isCheckboxAllLocationsChecked: false, isCheckboxAllCustomersChecked: false });
    }

    isStepSkipped = (step: number) => {
        return this.state.skipped.has(step);
    }

    handleNext = () => {
        let newSkipped = this.state.skipped;
        if (this.isStepSkipped(this.state.activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(this.state.activeStep);
        }

        if (this.state.activeStep === 0) {
            if (this.state.whisper.length > 300 || this.state.whisper.length === 0) {
                this.setState({ error: true, failed: {...this.state.failed, [this.state.activeStep]: true} });
            } else {
                this.setState({ error: false, failed: {...this.state.failed, [this.state.activeStep]: false} });
                this.setState({ activeStep: this.state.activeStep + 1, skipped: newSkipped });
            }
        }

        if (this.state.activeStep === 1) {
            if (
                (this.state.selectedCustomers.length === 0 && this.state.value === '0') || 
                (this.state.filteredSelectedCustomers.length === 0 && this.state.value === '1')
            ) {
                this.setState({ failed: {...this.state.failed, [this.state.activeStep]: true} });
            } else {
                this.setState({ failed: {...this.state.failed, [this.state.activeStep]: false} });
                this.setState({ activeStep: this.state.activeStep + 1, skipped: newSkipped });
            }
        }

        if (this.state.activeStep === 2) {
            this.setState({ activeStep: this.state.activeStep + 1, skipped: newSkipped });
        }
    };

    handleBack = () => {
        this.setState({ activeStep: this.state.activeStep - 1 });
    };

    handleSkip = () => {
        this.setState({ activeStep: this.state.activeStep + 1, skipped: new Set(this.state.skipped.values()) });
        this.setState({ skipped: new Set(this.state.skipped.values()) });
        this.setState({ activeStep: 0 });
    };

    handleReset = () => {
        this.setState({ activeStep: 0 });
    };

    handleWhisperTextChange = (value: string) => {
        this.setState({ whisper: value });
        if (value.length > 300 || value.length === 0) {
            this.setState({ error: true });
        } else {
            this.setState({ error: false });
        }
    }

    handleClearCustomersSelection = () => {
        const checkboxAllLocations = document.getElementsByName('checkbox-all-locations')[0] as HTMLInputElement | undefined;
        const checkboxAllCustomers = document.getElementsByName('checkbox-all-customers')[0] as HTMLInputElement | undefined;
        this.setState(
            { 
                filteredSelectedCustomers: [], 
                filteredCustomers: [], 
                selectedLocations: []
            },
            () => {
                if (checkboxAllLocations) {
                    this.setState({ isCheckboxAllLocationsChecked: false });
                }
                if (checkboxAllCustomers) {
                    this.setState({ isCheckboxAllCustomersChecked: false });
                }
            }
        );
    }

    handleChangeMultiple = async (event: SelectChangeEvent<string[]>, type: string) => {
        const target = event.target as unknown as HTMLSelectElement;
        const { options } = target;
        const selectedValues: string[] = [];
        for (let i = 0, l = options.length; i < l; i += 1) {
          if (options[i].selected) {
            selectedValues.push(options[i].value);
          }
        }
        console.log('selectedValues: ', selectedValues);
        console.log('type: ', type);
        if (type === 'locations') {
            this.setState({ selectedLocations: selectedValues });
            const csrfToken = await axios.get('/csrf/');
            await axios.post(`/admin/whispers/filter-customers/?entity_id=${localStorage.getItem('entity_id')}`, {
                locations: selectedValues,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken.data.csrfToken
                },
            })
            .then(res => {
                this.setState({ filteredCustomers: res.data.customers, selectedCustomers: [] });
            })
            .catch(err => {
                this.setState({ filteredCustomers: [] });
            });
        } else {
            this.setState({ 
                filteredSelectedCustomers: selectedValues
            });
        }
        console.log('filteredSelectedCustomers: ', this.state.filteredSelectedCustomers);
      };

    handleSaveAsDraft = async () => {
        this.setState({ loading: true });
        const csrfToken = await axios.get('/csrf/');
        await axios.post(`/admin/whispers/save-as-draft/?entity_id=${localStorage.getItem('entity_id')}`, {
            whisper: this.state.whisper,
            customers: this.state.selectedCustomers.length > 0 ? this.state.selectedCustomers : this.state.filteredSelectedCustomers,
            value: this.state.value,
            // channel: this.state.selectedChannel,
        }, {
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken.data.csrfToken
            },
        })
        .then(res => {
            this.setState({ success: true, message: res.data.message });
        })
        .catch(err => {
            this.setState({ success: false, message: err.response.data.message });
        })
        this.setState({ loading: false, activeStep: this.state.activeStep + 1 });
    }

    handleSubmit = async () => {
        this.setState({ loading: true });
        const csrfToken = await axios.get('/csrf/');
        await axios.post(`/admin/whispers/submit/?entity_id=${localStorage.getItem('entity_id')}`, {
            whisper: this.state.whisper,
            customers: this.state.selectedCustomers.length > 0 ? this.state.selectedCustomers : this.state.filteredSelectedCustomers,
            value: this.state.value,
            // channel: this.state.selectedChannel,
        }, {
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken.data.csrfToken
            },
        })
        .then(res => {
            this.setState({ success: true, message: res.data.message, all_steps_completed: true });
        })
        .catch(err => {
            this.setState({ success: false, message: err.response.data.message, all_steps_completed: true });
        })
        this.setState({ loading: false, activeStep: this.state.activeStep + 1 });
    }

    handleClearContent = () => {
        // this.setState({ whisper: '', selectedCustomers: [], selectedChannel: null });
        this.setState({ whisper: '', selectedCustomers: [] });
        this.setState({ activeStep: 0, skipped: new Set<number>() });
        this.setState({ error: false, failed: {} });
        this.setState({ loading: false });
    }

    handleToggleAllLocations = async () => {

        if (this.state.selectedLocations.length !== this.state.locations.length) {
            this.setState({ selectedLocations: this.state.locations.map((location: { id: number }) => location.id.toString()) });
        } else {
            this.setState({ selectedLocations: [] });
        }

        if (this.state.locations.length > 0) {
            const csrfToken = await axios.get('/csrf/');
            await axios.post(`/admin/whispers/filter-customers/?entity_id=${localStorage.getItem('entity_id')}`, {
                locations: this.state.selectedLocations,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken.data.csrfToken
                },
            })
            .then(res => {
                this.setState({ filteredCustomers: res.data.customers, selectedCustomers: [] });
            })
            .catch(err => {
                this.setState({ filteredCustomers: [] });
            });
        }
    };

    handleToggleAllCustomers = () => {
        if (this.state.filteredSelectedCustomers.length !== this.state.filteredCustomers.length) {
            this.setState({ filteredSelectedCustomers: this.state.filteredCustomers.map((customer: { id: number }) => customer.id.toString()) });
        } else {
            this.setState({ filteredSelectedCustomers: [] });
        }
    };

    render() {
        return (
            <ErrorBoundary fallback={<div>Error loading whispers</div>}>
                <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: 2 }}>
                    {/* <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs 
                            value={this.state.outer_tab_index} 
                            onChange={this.handleOuterTabIndexChange} 
                            aria-label="whisper creation tabs"
                        >
                            <Tab label="Create manual whisper" style={{ textTransform: 'capitalize' }} value="0"/>
                            <Tab label="Upload a file" style={{ textTransform: 'capitalize' }} value="1"/>
                        </Tabs>
                    </Box> */}
                    {/* {
                        this.state.outer_tab_index == 0 ? ( */}
                        <>
                            <Box sx={{ 
                                backgroundColor: this.state.mode === 'light' ? '#fff' : '#fff', 
                                borderTopRightRadius: 2, 
                                borderTopLeftRadius: 2, 
                                borderBottomRightRadius: 0,
                                borderBottomLeftRadius: 0,
                                width: '100%', 
                                height: '100%', 
                                display: 'flex', 
                                flexDirection: 'column', 
                                justifyContent: 'center', 
                                alignItems: 'center'
                            }}>
                                <Typography variant="h6" sx={{ fontSize: '1.5rem !important', textAlign: 'center', fontFamily: 'Trebuchet MS', fontWeight: 'bold' }}>Create a new whisper</Typography>
                                <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'center', fontFamily: 'Trebuchet MS' }}>
                                    Here you can create a new corporate whisper.<br/> A whisper is a message that will be sent to the users through the SMS tool.
                                </Typography>
                                <Stepper 
                                    activeStep={this.state.activeStep} 
                                    alternativeLabel 
                                    sx={{ marginTop: 5, flex: '1 1 auto', width: '100%' }}
                                >
                                    {this.state.steps.map((label, index) => {
                                        const stepProps: { completed?: boolean } = {};
                                        const labelProps: {
                                            optional?: React.ReactNode;
                                            error?: boolean;
                                        } = {};
                                        if (this.isStepSkipped(index)) {
                                            stepProps.completed = false;
                                        }

                                        if (this.state.failed[index]) {
                                            labelProps.error = true;
                                        }
                                        return (
                                            <Step key={label} {...stepProps}>
                                                <StepLabel {...labelProps}>{label}</StepLabel>
                                            </Step>
                                        );
                                    })}
                                </Stepper>
                                {this.state.activeStep === this.state.steps.length ? (
                                    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: 2 }}>
                                        {this.state.success ? (
                                            <CheckCircleRoundedIcon color="success" sx={{ fontSize: 40 }} />
                                        ) : (
                                            <ErrorIcon color="error" sx={{ fontSize: 40 }} />
                                        )}
                                        <Typography variant="body1" sx={{ mt: 2, mb: 1 }}>
                                            {this.state.message}
                                        </Typography>
                                        {this.state.success ? (
                                            <>
                                                <Divider />
                                                <Box sx={{ display: 'flex', flexDirection: 'column', pt: 2 }}>
                                                    <Button sx={{ textTransform: 'none', border: 0 }} onClick={() => window.location.href = '/admin/whispers/'}>Go to whisper index</Button>
                                                    <Box sx={{ flex: '1 1 auto' }} />
                                                    <Typography variant="body1" sx={{ mt: 2, mb: 1, textAlign: 'center' }}>or</Typography>
                                                    <Box sx={{ flex: '1 1 auto' }} />
                                                </Box>
                                            </>
                                        ) : null}
                                        <Button onClick={this.handleReset} sx={{ textTransform: 'none', border: 0 }}>Reset</Button>
                                    </Box>
                                ) : (
                                    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: 2 }}>
                                        {this.state.activeStep === 0 && (
                                            <>
                                                <TextField
                                                    required
                                                    multiline
                                                    id="whisper"
                                                    label="Please enter the whisper text"
                                                    value={this.state.whisper}
                                                    onChange={(e) => this.handleWhisperTextChange(e.target.value)}
                                                    rows={6}
                                                    error={this.state.error}
                                                    variant="outlined"
                                                    helperText={
                                                        this.state.whisper.length > 300 ? 
                                                        'The whisper text must not be more than 300 characters long' :
                                                        this.state.error && this.state.whisper.length === 0 ?
                                                        'The whisper text is required and must be 300 characters or less' :
                                                        ''
                                                    }
                                                    sx={{ width: '60%', fontFamily: 'inherit', marginBottom: 4, fontSize: '0.8rem' }}
                                                />
                                            
                                                {/* <div style={{ flex: 1, width: '60%', margin: 'auto' }}>
                                                    <Select<OptionType, false>
                                                        placeholder="Select a channel"
                                                        closeMenuOnSelect={true}
                                                        components={this.animatedComponents}
                                                        options={this.state.channels.map((channel: { id: number, description: string }) => ({
                                                            label: channel.description,
                                                            value: String(channel.id),
                                                        }))}
                                                        styles={{
                                                            control: (base) => ({
                                                                ...base,
                                                                width: '100%',
                                                            }),
                                                        }}
                                                        value={this.state.selectedChannel}
                                                        onChange={(newValue: OptionType) => this.setState({ selectedChannel: newValue })}
                                                    />
                                                </div> */}
                                            </>
                                        )}
                                        {this.state.activeStep === 1 && (
                                            <Box sx={{ border: '2px solid #e0e0e0', borderRadius: 2, padding: 2, width: '60%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', margin: '0 auto 5px auto' }}>
                                                <Tabs
                                                    centered
                                                    value={this.state.value}
                                                    onChange={(event: React.SyntheticEvent, newValue: string) => this.setState({ value: newValue as '0' | '1' })}
                                                    aria-label="Assign customer(s) tabs"
                                                    sx={{ borderRadius: 2, fontFamily: 'inherit', fontSize: '0.8rem', justifyContent: 'center', alignItems: 'center', marginBottom: 2 }}
                                                >
                                                    <Tab
                                                        value="0"
                                                        label="Search customer(s) through customer id"
                                                        wrapped
                                                    />
                                                    <Tab value="1" label="Search customer(s) through location and type" wrapped />
                                                </Tabs>
                                                {this.state.value === '0' && (
                                                    <Box sx={{ width: '70%', gap: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: 2, zIndex: 1000 }}>
                                                        <div style={{ flex: 1, width: '100%', margin: 'auto' }}>
                                                            <ReactSelect<OptionType, true>
                                                                placeholder="Search by customer id"
                                                                closeMenuOnSelect={false}
                                                                components={this.animatedComponents}
                                                                isMulti
                                                                options={this.state.customers.map((customer: { id: number, label: string, name: string, sys_id: string }) => ({
                                                                    id: customer.id,
                                                                    label: customer.label + ' (' + customer.sys_id + ')',
                                                                    value: customer.name,
                                                                    sys_id: customer.sys_id,
                                                                }))}
                                                                // styles={{
                                                                //     control: (base) => ({
                                                                //         ...base,
                                                                //         width: '100%',
                                                                //         backgroundColor: this.state.mode === 'light' ? '#fff' : '#ffffff27',
                                                                //     }),
                                                                styles={{
                                                                    option: (base) => ({
                                                                        ...base,
                                                                        color: '#000',
                                                                    }),
                                                                }}
                                                                value={this.state.selectedCustomers.map((customer: { id: number, label: string, name: string, sys_id: string }) => ({
                                                                    id: customer.id,
                                                                    label: customer.label,
                                                                    value: customer.name,
                                                                    sys_id: customer.sys_id,
                                                                }))}
                                                                onChange={this.handleChange}
                                                            />
                                                        </div>
                                                    </Box>
                                                )}
                                                {this.state.value === '1' && (
                                                    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: 2 }}>
                                                        <Grid container spacing={2} sx={{ width: '100%', height: '100%' }}>
                                                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
                                                                <Card variant="outlined" sx= {{ boxShdow: 'none', width: '100%', maxWidth: 500, height: '100%', border: 0 }}>
                                                                    <CardHeader 
                                                                        sx={{ px: 2, py: 1 }}
                                                                        title="Locations" 
                                                                        avatar = {
                                                                            <Checkbox sx={{ fontSize: '0.8rem !important', textAlign: 'center' }} 
                                                                                name="checkbox-all-locations"
                                                                                onClick={this.handleToggleAllLocations}
                                                                                checked={this.state.isCheckboxAllLocationsChecked}
                                                                                onChange={() => this.setState({ isCheckboxAllLocationsChecked: !this.state.isCheckboxAllLocationsChecked })}
                                                                            />
                                                                        }
                                                                        subheader={`${this.state.selectedLocations.length}/${this.state.locations.length} selected`}
                                                                        slotProps={{ 
                                                                            title: { sx: { fontSize: '1rem !important', textAlign: 'center' } },
                                                                            subheader: { sx: { fontSize: '0.8rem !important', textAlign: 'center' } },
                                                                            root: { sx: { borderBottom: 1, borderColor: 'divider'} }
                                                                        }} 
                                                                    />
                                                                    <CardContent sx={{ width: '100%', height: '100%' }}>
                                                                        <FormControl sx={{ m: 1, width: '100%' }}>
                                                                            <InputLabel shrink htmlFor="select-multiple-native">Select location(s)...</InputLabel>
                                                                            <Select<string[]>
                                                                                multiple
                                                                                native
                                                                                label="Select location(s)..."
                                                                                value={this.state.selectedLocations}
                                                                                onChange={(event: SelectChangeEvent<string[]>) => this.handleChangeMultiple(event, 'locations')}
                                                                                inputProps={{
                                                                                    id: 'select-location-multiple',
                                                                                }}
                                                                            >
                                                                                {this.state.locations.map((location: { id: number, label: string, name: string, sys_id: string }) => (
                                                                                    <option key={location.id} value={location.id.toString()}>
                                                                                        {location.label + ' (' + location.sys_id + ')'}
                                                                                    </option>
                                                                                ))}
                                                                            </Select>
                                                                        </FormControl>
                                                                    </CardContent>
                                                                </Card>
                                                            </Grid>
                                                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
                                                                <Card variant="outlined" sx= {{ boxShdow: 'none', width: '100%', maxWidth: 500, height: '100%', border: 0 }}>
                                                                    <CardHeader 
                                                                        sx={{ px: 2, py: 1 }}
                                                                        title="Customers" 
                                                                        avatar = {
                                                                            <Checkbox sx={{ fontSize: '0.8rem !important', textAlign: 'center' }} 
                                                                                name="checkbox-all-customers"
                                                                                onClick={this.handleToggleAllCustomers}
                                                                                checked={this.state.isCheckboxAllCustomersChecked}
                                                                                onChange={() => this.setState({ isCheckboxAllCustomersChecked: !this.state.isCheckboxAllCustomersChecked })}
                                                                            />
                                                                        }
                                                                        subheader={`${this.state.filteredSelectedCustomers.length}/${this.state.filteredCustomers.length} selected`}
                                                                        slotProps={{ 
                                                                            title: { sx: { fontSize: '1rem !important', textAlign: 'center' } },
                                                                            subheader: { sx: { fontSize: '0.8rem !important', textAlign: 'center' } },
                                                                            root: { sx: { borderBottom: 1, borderColor: 'divider'} }
                                                                        }} 
                                                                    />
                                                                    <CardContent>
                                                                        <FormControl sx={{ m: 1, width: '100%' }}>
                                                                            <InputLabel shrink htmlFor="select-customer-multiple">Select customer(s)...</InputLabel>
                                                                            <Select<string[]>
                                                                                multiple
                                                                                native
                                                                                label="Select customer(s)..."
                                                                                value={this.state.filteredSelectedCustomers}
                                                                                onChange={(event: SelectChangeEvent<string[]>) => this.handleChangeMultiple(event, 'customers')}
                                                                                inputProps={{
                                                                                    id: 'select-customer-multiple',
                                                                                }}
                                                                            >
                                                                                {this.state.filteredCustomers.map((customer: { id: number, label: string, name: string, sys_id: string }) => (
                                                                                    <option key={customer.id} value={customer.id.toString()}>
                                                                                        {customer.label + ' (' + customer.sys_id + ')'}
                                                                                    </option>
                                                                                ))}
                                                                            </Select>
                                                                        </FormControl>
                                                                    </CardContent>
                                                                    {this.state.filteredSelectedCustomers.length > 0 && (
                                                                        <CardActions sx={{ width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                                                                            <Button variant="contained" size="small" color="error" startIcon={<MinusIcon />} sx={{ textTransform: 'none', boxShadow: 'none', border: 0 }} onClick={this.handleClearCustomersSelection}>Clear selection</Button>
                                                                        </CardActions>
                                                                    )}
                                                                </Card>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                )}
                                            </Box>
                                        )}
                                        {this.state.activeStep === 2 && (
                                            <div style={{ margin: '0 auto 5px auto', width: '60%' }}>
                                                <Alert severity="warning" style={{ marginBottom: 4 }}>
                                                    Currently, the whisper is in an unsaved state. Please follow one of the following steps to not loose your work:
                                                    <ol>
                                                        <li>Save the whisper as a draft by clicking the <b>"Save as draft"</b> button</li>
                                                        <li>Submit the whisper by clicking the <b>"Submit"</b> button (this will make the whisper available to the users)</li>
                                                    </ol>
                                                    <hr/>
                                                    <b><u>Important:</u></b> By clicking the button <b>"Clear content and start over"</b>, you will lose all the work you have done so far and you are resetting the entire process.
                                                </Alert>
                                                <Accordion
                                                    expanded={this.state.expanded === 'panel1'}
                                                    onChange={this.handleAccordionChange('panel1')}
                                                    sx={{ boxShadow: 'none' }}
                                                >
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="panel1bh-content"
                                                        id="panel1bh-header"
                                                    >
                                                    <Typography component="span" sx={{ width: '33%', flexShrink: 0 }}>Whisper</Typography>
                                                    <Typography component="span" sx={{ color: 'text.secondary' }}>
                                                        {(this.state.whisper ? this.state.whisper.substring(0, 50) : '')}...
                                                    </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', fontSize: 'clamp(0.5rem, 3vw, 0.9rem) !important' }}>{this.state.whisper}</Typography>
                                                    </AccordionDetails>
                                                </Accordion>
                                                <Accordion
                                                    expanded={this.state.expanded === 'panel2'}
                                                    onChange={this.handleAccordionChange('panel2')}
                                                    sx={{ boxShadow: 'none' }}
                                                >
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="panel2bh-content"
                                                        id="panel2bh-header"
                                                    >
                                                        <Typography component="span" sx={{ width: '33%', flexShrink: 0 }}>Customers</Typography>
                                                        <Typography component="span" sx={{ color: 'text.secondary' }}>
                                                            {
                                                                this.state.selectedCustomers.length > 0 ? this.state.selectedCustomers.length 
                                                                : this.state.filteredSelectedCustomers.length > 0 ? this.state.filteredSelectedCustomers.length 
                                                                : 'No customers selected'
                                                            }
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                            <DataGrid
                                                                rows={
                                                                    this.state.selectedCustomers.length > 0 ? this.state.selectedCustomers.map((customer: { id: number, label: string, name: string, sys_id: string }) => ({
                                                                        id: customer.id,
                                                                        label: customer.label,
                                                                        value: customer.name,
                                                                        sys_id: customer.sys_id,
                                                                    }))
                                                                    : this.state.filteredCustomers.filter((customer: { id: number }) => this.state.filteredSelectedCustomers.includes(customer.id.toString())).map((customer: { id: number, label: string, name: string, sys_id: string }) => ({
                                                                        id: customer.id,
                                                                        label: customer.label,
                                                                        value: customer.name,
                                                                        sys_id: customer.sys_id,
                                                                    })) || []
                                                                }
                                                                columns={[
                                                                    { field: 'id', headerName: 'ID', width: 80 }, 
                                                                    { field: 'label', headerName: 'Name', width: 300 },
                                                                    { field: 'sys_id', headerName: 'Cust ID', width: 100 }
                                                                ]}
                                                                initialState={{
                                                                    pagination: { paginationModel: { pageSize: 10 } },
                                                                    sorting: { sortModel: [{ field: 'id', sort: 'asc' }] },
                                                                }}
                                                                pageSizeOptions={[5, 10, 20, 50, 100]}
                                                                showToolbar
                                                                getRowHeight={() => 30}
                                                                sx={{ width: '100%', border: 'none', minHeight: '300px', maxHeight: 400, borderRadius: '10px', }}
                                                            />
                                                        </Box>
                                                    </AccordionDetails>
                                                </Accordion>
                                                <Accordion
                                                    expanded={this.state.expanded === 'panel3'}
                                                    onChange={this.handleAccordionChange('panel3')}
                                                    sx={{ boxShadow: 'none' }}
                                                >
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="panel3bh-content"
                                                        id="panel3bh-header"
                                                    >
                                                        <Typography component="span" sx={{ width: '33%', flexShrink: 0 }}>General Details</Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <Grid container spacing={2}>
                                                            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                                                                <Typography component="span" sx={{ color: 'text.secondary' }}>Channel</Typography>
                                                                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                                    <ListItem alignItems="flex-start">
                                                                        <ListItemText
                                                                            primary="Type"
                                                                            secondary={
                                                                                <React.Fragment>
                                                                                    <Typography
                                                                                        component="span"
                                                                                        variant="body2"
                                                                                        sx={{ color: 'text.primary', display: 'inline' }}
                                                                                    >
                                                                                        C(orporate)
                                                                                    </Typography>
                                                                                    {" - this is a corporate type of whisper"}
                                                                                </React.Fragment>
                                                                            }
                                                                        />
                                                                    </ListItem>
                                                                </List>
                                                            </Grid>
                                                            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                                                                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                                    <Typography component="span" sx={{ color: 'text.secondary' }}>Whisper</Typography>
                                                                    <ListItem alignItems="flex-start">
                                                                        <ListItemText
                                                                            primary="Status"
                                                                            secondary={
                                                                                <React.Fragment>
                                                                                    <Typography
                                                                                        component="span"
                                                                                        variant="body2"
                                                                                        sx={{ color: 'text.primary', display: 'inline' }}
                                                                                    >
                                                                                        Unsaved
                                                                                    </Typography>
                                                                                    {" - the whisper is currently in an unsaved state"}
                                                                                </React.Fragment>
                                                                            }
                                                                        />
                                                                    </ListItem>
                                                                </List>
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </div>)
                                        }
                                    </Box>
                                )}
                            </Box>
                            <Divider />
                            <Box sx={{ 
                                backgroundColor: this.state.mode === 'light' ? '#fff' : '#fff',
                                padding: 2,
                                width: '100%', 
                                height: 'auto', 
                                display: 'flex', 
                                flexDirection: 'row', 
                                justifyContent: 'center', 
                                alignItems: 'center',
                                borderBottomRightRadius: 2,
                                borderBottomLeftRadius: 2,
                            }}>
                                <Button
                                    variant="contained"
                                    size="small"
                                    color="secondary"
                                    disabled={this.state.activeStep === 0}
                                    onClick={this.handleBack}
                                    sx={{ mr: 1, boxShadow: 'none', textTransform: 'capitalize', border: 0 }}
                                >
                                    Back
                                </Button>
                                <Box sx={{ flex: '1 1 auto' }} />
                                {this.state.activeStep === 2 && (
                                    <>
                                        <Button 
                                            variant="contained" 
                                            color="error" 
                                            size="small" 
                                            onClick={this.handleClearContent} 
                                            sx={{ boxShadow: 'none', textTransform: 'capitalize', border: 0, marginRight: 1 }}
                                        >
                                            Clear content and start over
                                        </Button>
                                        <Button 
                                            variant="contained" 
                                            startIcon={<SaveIcon />} 
                                            color="warning" 
                                            size="small" 
                                            loadingPosition="end"
                                            loading={this.state.loading}
                                            onClick={this.handleSaveAsDraft}
                                            sx={{ boxShadow: 'none', marginRight: 1, border: 0, textTransform: 'capitalize' }}
                                        >
                                            {!this.state.loading ? 'Save as draft' : 'Saving...'}
                                        </Button>
                                    </>
                                )}
                                {
                                    this.state.activeStep !== this.state.steps.length - 1 && !this.state.all_steps_completed ? (
                                        <Button variant="contained" size="small" onClick={this.handleNext} sx={{ boxShadow: 'none', textTransform: 'capitalize', border: 0 }}>
                                            Next
                                        </Button>
                                    ) : !this.state.all_steps_completed ? (
                                        <Button variant="contained" size="small" onClick={this.handleSubmit} sx={{ boxShadow: 'none', textTransform: 'capitalize', border: 0 }}>
                                            Submit
                                        </Button>
                                    ) : null
                                }

                            </Box>
                        </>
                    {/* ) : (
                        <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                            <UploadedFileDataTable />
                        </Box>
                    )} */}
                </Box>
            </ErrorBoundary>
        )
    }
}
